<template>
  <div>
    <div class="page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">
          {{ $t('payments.title') }}
        </h4>
      </div>
    </div>
    <div class="row mt-3">
      <!-- Free -->
      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-header bg-success">
            <h5 class="text-white cursor-pointer m-0" @click="() => collapseSidebar('toggleFree')">
              <i class="far fa-star"></i>
              <span> Free</span>
              <a class="pull-right" data-toggle="dropdown">
                <span>
                  <i class="fa" :class="{
                    'fa-angle-up': !this.form.toggleFree,
                    'fa-angle-down': this.form.toggleFree
                  }"></i>
                </span>
              </a>
            </h5>
          </div>
          <div class="card-body" v-if="!this.form.toggleFree">
            <p style="visibility: hidden;">
              <input type="radio" value="monthly" v-model="freeSelected" checked> {{ $t('payments.monthly') }}
              <input type="radio" value="yearly" v-model="freeSelected"> {{ $t('payments.yearly') }}
            </p>
            <div class="container">
              <div class="circle free">
                <span v-if="freeSelected === 'monthly'" class="price">{{ price_table.free.mPrice }}</span>
                <span v-else class="price">{{ price_table.free.yPrice }}</span>
                <span class="unit">Đồng</span>
              </div>
            </div>
            <div class="features-table">
              <table>
                <thead>
                  <tr>
                    <th style="width: 30%;">{{ $t('payments.feature') }}</th>
                    <th style="width: 20%;">{{ $t('payments.capacity') }}</th>
                    <th>{{ $t('payments.brief') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(feature, index) in price_table.features" :key="index">
                    <td>
                      <span><i :class="getFeatureIcons(`${feature.id}`)"></i></span>
                      {{ feature.name }}
                    </td>
                    <td>
                      <span :style="{ color: getValueColor(`${feature.free}`) }">
                        <i :class="getAvailableIcons(`${feature.free}`)"></i>
                      </span>
                    </td>
                    <td>
                      {{ truncateDescription(feature.description) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Standard -->
      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-header bg-purple">
            <div class="ribbon">Recommended</div>
            <h5 class="text-white cursor-pointer m-0" @click="() => collapseSidebar('toggleStd')">
              <i class="far fa-star"></i>
              <i class="far fa-star"></i>
              <span> Standard</span>
              <a class="pull-right" data-toggle="dropdown">
                <span>
                  <i class="fa" :class="{
                    'fa-angle-up': !this.form.toggleStd,
                    'fa-angle-down': this.form.toggleStd
                  }"></i>
                </span>
              </a>
            </h5>
          </div>
          <div class="card-body" v-if="!this.form.toggleStd">
            <p>
              <input type="radio" value="monthly" v-model="standardSelected" checked> {{ $t('payments.monthly') }}
              <input type="radio" value="yearly" v-model="standardSelected"> {{ $t('payments.yearly') }}
              <link-button :classes="['btn-success', 'standard', 'pull-right']" :click="() => purchase('standard')">
                {{ $t('payments.upgrade_now') }}
              </link-button>
            </p>
            <div class="container">
              <div class="circle standard">
                <span v-if="standardSelected === 'monthly'" class="price">{{ price_table.standard.mPrice }}</span>
                <span v-else class="price">{{ price_table.standard.yPrice }}</span>
                <span class="unit">k Đồng</span>
              </div>
            </div>
            <div class="features-table">
              <table>
                <thead>
                  <tr>
                    <th style="width: 30%;">{{ $t('payments.feature') }}</th>
                    <th style="width: 20%;">{{ $t('payments.capacity') }}</th>
                    <th>{{ $t('payments.brief') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(feature, index) in price_table.features" :key="index">
                    <td>
                      <span><i :class="getFeatureIcons(`${feature.id}`)"></i></span>
                      {{ feature.name }}
                    </td>
                    <td>
                      <span :style="{ color: getValueColor(`${feature.standard}`) }">
                        <i :class="getAvailableIcons(`${feature.standard}`)"></i>
                      </span>
                    </td>
                    <td>
                      {{ truncateDescription(feature.description) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Premium -->
      <div class="col-lg-4 col-md-4">
        <div class="card">
          <div class="card-header bg-golden">
            <h5 class="text-white cursor-pointer m-0" @click="() => collapseSidebar('togglePre')">
              <i class="far fa-star"></i>
              <i class="far fa-star"></i>
              <i class="far fa-star"></i>
              <span> Premium</span>
              <a class="pull-right" data-toggle="dropdown">
                <span>
                  <i class="fa" :class="{
                    'fa-angle-up': !this.form.togglePre,
                    'fa-angle-down': this.form.togglePre
                  }"></i>
                </span>
              </a>
            </h5>
          </div>
          <div class="card-body" v-if="!this.form.togglePre">
            <p>
              <input type="radio" value="monthly" v-model="premiumSelected" checked> {{ $t('payments.monthly') }}
              <input type="radio" value="yearly" v-model="premiumSelected"> {{ $t('payments.yearly') }}
              <link-button :classes="['btn-success', 'premium', 'pull-right']" :click="() => purchase('premium')">
                {{ $t('payments.upgrade_now') }}
              </link-button>
            </p>
            <div class="container">
              <div class="circle premium">
                <span v-if="premiumSelected === 'monthly'" class="price">{{ price_table.premium.mPrice }}</span>
                <span v-else class="price">{{ price_table.premium.yPrice }}</span>
                <span class="unit">k Đồng</span>
              </div>
            </div>
            <div class="features-table">
              <table>
                <thead>
                  <tr>
                    <th style="width: 30%;">{{ $t('payments.feature') }}</th>
                    <th style="width: 20%;">{{ $t('payments.capacity') }}</th>
                    <th>{{ $t('payments.brief') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(feature, index) in price_table.features" :key="index">
                    <td>
                      <span><i :class="getFeatureIcons(`${feature.id}`)"></i></span>
                      {{ feature.name }}
                    </td>
                    <td>
                      <span :style="{ color: getValueColor(`${feature.premium}`) }">
                        <i :class="getAvailableIcons(`${feature.premium}`)"></i>
                      </span>
                    </td>
                    <td class="feature-description">
                      {{ truncateDescription(feature.description) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RadioButton from '@/components/Form/RadioButton.vue';
import LinkButton from "@/components/Misc/LinkButton";
import common from "@/libs/common";
import i18n from '@/i18n';

export default {
  name: 'Payment',
  components: {
    RadioButton,
    LinkButton
  },
  data() {
    return {
      premiumSelected: 'monthly',
      standardSelected: 'monthly',
      freeSelected: 'monthly',
      price_table: {
        free: {
          mPrice: 0.0,
          yPrice: 0.0,
        },
        standard: {
          mPrice: 49,
          yPrice: 552,
        },
        premium: {
          mPrice: 69,
          yPrice: 736,
        },
        features: [
          {
            id: 'ranking',
            name: i18n.t('ranking.title'),
            free: false,
            standard: false,
            premium: true,
            description: i18n.t('introductions.ranking')
          },
          {
            id: 'market_cycle',
            name: i18n.t('features.market_cycle'),
            free: false,
            standard: true,
            premium: true,
            description: i18n.t('introductions.market_cycle')
          },
          {
            id: 'competitors',
            name: i18n.t('features.competitors'),
            free: false,
            standard: true,
            premium: true,
            description: i18n.t('introductions.competitors')
          },
          {
            id: 'dca',
            name: i18n.t('stocks.dca.title'),
            free: true,
            standard: true,
            premium: true,
            description: i18n.t('introductions.dca')
          },
          {
            id: 'mos',
            name: i18n.t('stocks.mos.title'),
            free: true,
            standard: true,
            premium: true,
            description: i18n.t('introductions.mos')
          },
          {
            id: 'financial_ratios',
            name: i18n.t('features.financial_ratios'),
            free: true,
            standard: true,
            premium: true,
            description: i18n.t('introductions.financial_ratios')
          },
          {
            id: 'portfolio',
            name: i18n.t('features.portfolio'),
            free: true,
            standard: true,
            premium: true,
            description: i18n.t('introductions.portfolio')
          },
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: "payment/loading",
      form: "payment/form",
    })
  },

  methods: {
    ...mapActions({
      setField: "payment/setField",
      upgrade: "payment/upgrade"
    }),
    purchase(type) {
      const payload = {};
      payload['role'] = type;
      if (type === 'premium') {
        payload['period'] = this.premiumSelected;
      } else {
        payload['period'] = this.standardSelected;
      }
      console.log("Payload: ", payload);
      this.upgrade(payload);
    },
    getValueColor(value) {
      return value === 'true' ? 'var(--green)' : 'var(--red)';
    },
    getFeatureIcons(feature) {
      return common.getFeatureIcons(feature);
    },
    getAvailableIcons(value) {
      return common.getAvailableIcons(value);
    },
    truncateDescription(desc) {
      const maxLength = 50;
      return desc.length > maxLength ? desc.slice(0, maxLength) + '...' : desc;
    },
    collapseSidebar(key) {
      this.setField({ key: key, value: !this.form[key] });
    },
  }
}
</script>

<style scoped>
.ribbon {
  position: absolute;
  top: 15px;
  right: -30px;
  /* background-color: var(--purple); */
  background: linear-gradient(to bottom right, var(--white), var(--purple));
  color: var(--white);
  padding: 5px 10px;
  transform: rotate(45deg);
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 220px;
}

.circle {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  /* background-color: var(--yellow); */
  display: flex;
  justify-content: center;
  align-items: center;
}

.standard {
  background: linear-gradient(to bottom right, var(--white), var(--purple));
}

.premium {
  background: linear-gradient(to bottom right, var(--white), var(--yellow));
}

.free {
  background: linear-gradient(to bottom right, var(--white), var(--green));
}

.price {
  color: white;
  font-size: 60px;
}

.unit {
  color: white;
  font-size: 30px;
}

.features-table {
  border-collapse: collapse;
}

.features-table td,
th {
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
}

.feature-description {
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>